import React from "react"
import styled from "styled-components"
import { medWrapper, colors } from "../../styles/helpers"

import HeaderBottomNav from "./HeaderBottomNav"

const HeaderBottomSec = styled.div`
  display: none;
  position: relative;
  padding-bottom: 2.5rem;
  background-color: ${colors.white};
  z-index: 9999999999999999999;

  @media (min-width: 768px) {
    display: block;
  }

  .wrapper {
    ${medWrapper}

    @media (min-width: 768px) {
      justify-content: center;
      padding: 0 2rem;
    }

    @media (min-width: 1025px) {
      padding: 0 5rem;
    }
  }
`

const HeaderBottom = ({
  location,
  setAppDownload,
  handleModalState,
  isActive,
}) => {
  return (
    <HeaderBottomSec>
      <div className="wrapper">
        <HeaderBottomNav
          handleModalState={handleModalState}
          location={location}
          isActive={isActive}
          setAppDownload={setAppDownload}
        />
      </div>
    </HeaderBottomSec>
  )
}

export default HeaderBottom
